<!-- 分享按钮 -->
<template>
  <span>
    <button
      :disabled="disabled"
      :class="btnClass || $style['share-btn']"
      style="vertical-align: top;"
      @click="onClick"
    >
      {{ btnText }}
    </button>
    <van-popup
      v-model="visible"
      get-container="body"
      style="width: 100%; height: 100%; background-color: transparent; overflow-y: visible"
    >
      <div :class="$style['share-tip']" @click="handleClose" />
    </van-popup>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { share } from "@/api";

export default {
  name: "BtnShare",
  props: {
    btnText: { type: String, default: "" },
    btnClass: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    needShare: { type: Boolean, default: true }
  },
  emits: ["before-click", "close", "custom-click"],
  data() {
    return {
      visible: false
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    async onClick() {
      // 执行自定义前置事件
      if (this.$listeners["before-click"]) {
        const handler = this.$listeners["before-click"];
        if (typeof handler === "function" && handler() === false) {
          return;
        }
      }

      // 执行自定义点击事件
      if (this.$listeners["custom-click"]) {
        const handler = this.$listeners["custom-click"];
        if (typeof handler === "function") {
          const result = handler();
          if (result && typeof result.then === "function") {
            const shouldContinue = await result;
            if (shouldContinue === false) return;
          } else if (result === false) {
            return;
          }
        }
      }

      this.visible = true;
      // 请求分享接口
      if (this.needShare && this.user && Object.keys(this.user).length > 0) {
        share();
      }
    },
    handleClose() {
      this.visible = false;
      if (this.$listeners.close) {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="less" module>
.share {
  &-btn {
    .size(1rem, 1.2rem);
    .background-fill("./images/share-btn.png");

    vertical-align: top;
  }

  &-tip {
    .size(100%);

    &::after {
      .size(4.26rem, 2.16rem);
      .background-fill("./images/share-tip.png");

      content: "";
      position: absolute;
      top: 0.4rem;
      right: 0.4rem;
    }
  }
}
</style>
